module.exports = __webpack_public_path__ + "img/womans-hat.2c134e72.png";